import { render, staticRenderFns } from "./GroupSidebar.vue?vue&type=template&id=ff506f46"
import script from "./GroupSidebar.vue?vue&type=script&lang=ts"
export * from "./GroupSidebar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports